module.exports = __webpack_public_path__ + "static/media/itsallaboutme.22645711.jpg";